/**
 * Tipos e interfaces da aplicação Business Locator
 */

// Tipos de coordenadas geográficas
export interface Coordinates {
  lat: number;
  lng: number;
}

// Tipos de setores de negócio baseados no Google Places API
export enum BusinessSector {
  // GERAL
  TODOS = 'establishment',
  
  // ALIMENTAÇÃO E BEBIDAS
  RESTAURANTE = 'restaurant',
  CAFE = 'cafe',
  PADARIA = 'bakery',
  BAR = 'bar',
  LANCHONETE = 'meal_takeaway',
  ENTREGA_COMIDA = 'meal_delivery',
  
  // COMPRAS E VAREJO
  LOJA = 'store',
  SHOPPING = 'shopping_mall',
  SUPERMERCADO = 'supermarket',
  MERCADO = 'grocery_or_supermarket',
  CONVENIENCIA = 'convenience_store',
  LOJA_ROUPA = 'clothing_store',
  LOJA_CALCADOS = 'shoe_store',
  JOALHERIA = 'jewelry_store',
  LOJA_MOVEIS = 'furniture_store',
  LOJA_ELETRONICOS = 'electronics_store',
  LOJA_LIVROS = 'book_store',
  LOJA_BICICLETAS = 'bicycle_store',
  FLORICULTURA = 'florist',
  PET_SHOP = 'pet_store',
  LOJA_FERRAGENS = 'hardware_store',
  LOJA_BEBIDAS = 'liquor_store',
  FARMACIA = 'pharmacy',
  
  // SERVIÇOS
  LAVANDERIA = 'laundry',
  CABELEIREIRO = 'hair_care',
  SPA = 'spa',
  BELEZA = 'beauty_salon',
  ACADEMIA = 'gym',
  ESTACIONAMENTO = 'parking',
  POSTO_GASOLINA = 'gas_station',
  OFICINA = 'car_repair',
  LAVAGEM_CARRO = 'car_wash',
  ALUGUEL_CARRO = 'car_rental',
  
  // SAÚDE
  HOSPITAL = 'hospital',
  CLINICA = 'doctor',
  DENTISTA = 'dentist',
  FISIOTERAPEUTA = 'physiotherapist',
  VETERINARIO = 'veterinary_care',
  
  // SERVIÇOS PROFISSIONAIS
  ADVOGADO = 'lawyer',
  CONTADOR = 'accounting',
  IMOBILIARIA = 'real_estate_agency',
  SEGURADORA = 'insurance_agency',
  AGENCIA_VIAGEM = 'travel_agency',
  
  // FINANÇAS
  BANCO = 'bank',
  ATM = 'atm',
  
  // HOSPEDAGEM
  HOTEL = 'lodging',
  
  // TRANSPORTE
  AEROPORTO = 'airport',
  ESTACAO_ONIBUS = 'bus_station',
  METRO = 'subway_station',
  TREM = 'train_station',
  TAXI = 'taxi_stand',
  
  // EDUCAÇÃO
  ESCOLA = 'school',
  UNIVERSIDADE = 'university',
  BIBLIOTECA = 'library',
  
  // ENTRETENIMENTO E LAZER
  CINEMA = 'movie_theater',
  MUSEU = 'museum',
  PARQUE = 'park',
  ZOOLOGICO = 'zoo',
  PARQUE_DIVERSAO = 'amusement_park',
  AQUARIO = 'aquarium',
  BOLICHE = 'bowling_alley',
  CASSINO = 'casino',
  ESTADIO = 'stadium',
  
  // RELIGIÃO
  IGREJA = 'church',
  MESQUITA = 'mosque',
  SINAGOGA = 'synagogue',
  TEMPLO = 'hindu_temple',
  
  // GOVERNO E SERVIÇOS PÚBLICOS
  PREFEITURA = 'local_government_office',
  CORREIOS = 'post_office',
  DELEGACIA = 'police',
  BOMBEIROS = 'fire_station',
  CARTORIO = 'courthouse',
  
  // OUTROS
  FUNERARIA = 'funeral_home',
  CEMITERIO = 'cemetery',
  EMPREITEIRO = 'general_contractor',
  ELETRICISTA = 'electrician',
  ENCANADOR = 'plumber',
  PINTOR = 'painter',
  CHAVEIRO = 'locksmith',
  MUDANCAS = 'moving_company',
  
  // TECNOLOGIA E MÍDIA
  LOJA_INFORMATICA = 'computer_store',
  ASSISTENCIA_TECNICA = 'electronics_repair',
  GRAFICA = 'print_shop',
  PAPELARIA = 'stationery_store',
  FOTOGRAFIA = 'photography_studio',
  
  // ALIMENTAÇÃO ESPECIALIZADA
  PIZZARIA = 'pizza_restaurant',
  HAMBURGUERIA = 'hamburger_restaurant',
  SORVETERIA = 'ice_cream_shop',
  DOCERIA = 'dessert_shop',
  SUSHI = 'sushi_restaurant',
  
  // SERVIÇOS ESPECIALIZADOS
  COWORKING = 'coworking_space',
  DEPOSITO = 'storage',
  DESPACHANTE = 'logistics_service',
  ARQUITETO = 'architect',
  DESIGNER = 'interior_design',
  
  // VAREJO ESPECIALIZADO
  OTICA = 'optician',
  RELOJOARIA = 'watch_store',
  BRINQUEDOS = 'toy_store',
  ARTIGOS_ESPORTE = 'sporting_goods_store',
  INSTRUMENTOS_MUSICAIS = 'musical_instruments_store',
  
  // ALIMENTAÇÃO SAUDÁVEL
  LOJA_PRODUTOS_NATURAIS = 'health_food_store',
  SUPLEMENTOS = 'vitamin_supplements_store',
  
  // AUTOMOTIVO
  CONCESSIONARIA = 'car_dealer',
  BORRACHARIA = 'tire_shop',
  FUNILARIA = 'auto_body_shop',
  
  // CONSTRUÇÃO E REFORMA
  LOJA_MATERIAIS = 'building_materials_store',
  MADEIREIRA = 'lumber_yard',
  VIDRACARIA = 'glass_shop',
  
  // NOVOS SETORES - ALIMENTAÇÃO
  ACOUGUE = 'butcher_shop',
  PEIXARIA = 'seafood_market',
  HORTIFRUTI = 'fruit_and_vegetable_store',
  ADEGA = 'wine_store',
  DISTRIBUIDORA = 'food_distributor',
  ROTISSERIA = 'rotisserie',
  
  // NOVOS SETORES - BELEZA E ESTÉTICA
  MANICURE = 'nail_salon',
  TATUAGEM = 'tattoo_shop',
  BARBEARIA = 'barber_shop',
  ESTETICA = 'beauty_clinic',
  BRONZEAMENTO = 'tanning_salon',
  
  // NOVOS SETORES - SAÚDE ESPECIALIZADA
  PSICOLOGO = 'psychologist',
  NUTRICIONISTA = 'nutritionist',
  MASSAGEM = 'massage_therapist',
  ACUPUNTURA = 'acupuncture_clinic',
  LABORATORIO = 'medical_lab',
  
  // NOVOS SETORES - SERVIÇOS PARA CASA
  JARDINAGEM = 'landscaping',
  DEDETIZACAO = 'pest_control',
  LIMPEZA = 'cleaning_service',
  SEGURANCA = 'security_service',
  PORTARIA = 'guard_service',
  
  // NOVOS SETORES - AUTOMOTIVO ESPECIALIZADO
  INSULFILM = 'car_window_tinting',
  SOM_AUTOMOTIVO = 'car_audio',
  REBOQUE = 'towing_service',
  DESPACHANTE_VEICULAR = 'vehicle_registration',
  
  // NOVOS SETORES - VAREJO ESPECIALIZADO
  PERFUMARIA = 'perfume_store',
  COSMETICOS = 'cosmetics_store',
  TABACARIA = 'tobacco_shop',
  CONVENIENCIA_POSTO = 'convenience_store',
  
  // NOVOS SETORES - ENTRETENIMENTO
  KARAOKE = 'karaoke',
  BILHAR = 'billiards',
  FLIPERAMA = 'arcade',
  ESCAPE_ROOM = 'escape_room',
  
  // NOVOS SETORES - TECNOLOGIA
  LAN_HOUSE = 'internet_cafe',
  ASSISTENCIA_CELULAR = 'cell_phone_repair',
  LOJA_GAMES = 'video_game_store',
  
  // NOVOS SETORES - MODA E ACESSÓRIOS
  BOUTIQUE = 'boutique',
  LOJA_BOLSAS = 'handbag_store',
  LINGERIE = 'lingerie_store',
  LOJA_SURF = 'surf_shop',
  
  // NOVOS SETORES - ALIMENTAÇÃO ÉTNICA
  RESTAURANTE_CHINES = 'chinese_restaurant',
  RESTAURANTE_ITALIANO = 'italian_restaurant',
  RESTAURANTE_MEXICANO = 'mexican_restaurant',
  CHURRASCARIA = 'steakhouse',
  RESTAURANTE_VEGETARIANO = 'vegetarian_restaurant',
  
  // NOVOS SETORES - SERVIÇOS DIVERSOS
  COPIADORA = 'copy_shop',
  CORRETOR = 'real_estate_agent',
  TRADUTOR = 'translator',
  FOTOGRAFO = 'photographer',
  VIDEOMAKER = 'video_production'
}

// Labels para exibição dos setores (organizados por categoria)
export const BusinessSectorLabels: Record<BusinessSector, string> = {
  // GERAL
  [BusinessSector.TODOS]: '🔍 Todos os Estabelecimentos',
  
  // ALIMENTAÇÃO E BEBIDAS
  [BusinessSector.RESTAURANTE]: '🍽️ Restaurante',
  [BusinessSector.CAFE]: '☕ Café',
  [BusinessSector.PADARIA]: '🥖 Padaria',
  [BusinessSector.BAR]: '🍺 Bar',
  [BusinessSector.LANCHONETE]: '🍔 Lanchonete',
  [BusinessSector.ENTREGA_COMIDA]: '🛵 Entrega de Comida',
  
  // COMPRAS E VAREJO
  [BusinessSector.LOJA]: '🏪 Loja',
  [BusinessSector.SHOPPING]: '🏬 Shopping Center',
  [BusinessSector.SUPERMERCADO]: '🛒 Supermercado',
  [BusinessSector.MERCADO]: '🏪 Mercado',
  [BusinessSector.CONVENIENCIA]: '🏪 Loja de Conveniência',
  [BusinessSector.LOJA_ROUPA]: '👕 Loja de Roupas',
  [BusinessSector.LOJA_CALCADOS]: '👞 Loja de Calçados',
  [BusinessSector.JOALHERIA]: '💍 Joalheria',
  [BusinessSector.LOJA_MOVEIS]: '🛋️ Loja de Móveis',
  [BusinessSector.LOJA_ELETRONICOS]: '📱 Loja de Eletrônicos',
  [BusinessSector.LOJA_LIVROS]: '📚 Livraria',
  [BusinessSector.LOJA_BICICLETAS]: '🚲 Loja de Bicicletas',
  [BusinessSector.FLORICULTURA]: '💐 Floricultura',
  [BusinessSector.PET_SHOP]: '🐾 Pet Shop',
  [BusinessSector.LOJA_FERRAGENS]: '🔨 Loja de Ferragens',
  [BusinessSector.LOJA_BEBIDAS]: '🍷 Loja de Bebidas',
  [BusinessSector.FARMACIA]: '💊 Farmácia',
  
  // SERVIÇOS
  [BusinessSector.LAVANDERIA]: '🧺 Lavanderia',
  [BusinessSector.CABELEIREIRO]: '💇 Cabeleireiro',
  [BusinessSector.SPA]: '🧖 Spa',
  [BusinessSector.BELEZA]: '💅 Salão de Beleza',
  [BusinessSector.ACADEMIA]: '💪 Academia',
  [BusinessSector.ESTACIONAMENTO]: '🅿️ Estacionamento',
  [BusinessSector.POSTO_GASOLINA]: '⛽ Posto de Gasolina',
  [BusinessSector.OFICINA]: '🔧 Oficina Mecânica',
  [BusinessSector.LAVAGEM_CARRO]: '🚿 Lava-Jato',
  [BusinessSector.ALUGUEL_CARRO]: '🚗 Aluguel de Carros',
  
  // SAÚDE
  [BusinessSector.HOSPITAL]: '🏥 Hospital',
  [BusinessSector.CLINICA]: '👨‍⚕️ Clínica Médica',
  [BusinessSector.DENTISTA]: '🦷 Dentista',
  [BusinessSector.FISIOTERAPEUTA]: '🏃 Fisioterapeuta',
  [BusinessSector.VETERINARIO]: '🐕 Veterinário',
  
  // SERVIÇOS PROFISSIONAIS
  [BusinessSector.ADVOGADO]: '⚖️ Advogado',
  [BusinessSector.CONTADOR]: '📊 Contador',
  [BusinessSector.IMOBILIARIA]: '🏠 Imobiliária',
  [BusinessSector.SEGURADORA]: '🛡️ Seguradora',
  [BusinessSector.AGENCIA_VIAGEM]: '✈️ Agência de Viagem',
  
  // FINANÇAS
  [BusinessSector.BANCO]: '🏦 Banco',
  [BusinessSector.ATM]: '💳 Caixa Eletrônico',
  
  // HOSPEDAGEM
  [BusinessSector.HOTEL]: '🏨 Hotel',
  
  // TRANSPORTE
  [BusinessSector.AEROPORTO]: '✈️ Aeroporto',
  [BusinessSector.ESTACAO_ONIBUS]: '🚌 Estação de Ônibus',
  [BusinessSector.METRO]: '🚇 Estação de Metrô',
  [BusinessSector.TREM]: '🚆 Estação de Trem',
  [BusinessSector.TAXI]: '🚕 Ponto de Táxi',
  
  // EDUCAÇÃO
  [BusinessSector.ESCOLA]: '🏫 Escola',
  [BusinessSector.UNIVERSIDADE]: '🎓 Universidade',
  [BusinessSector.BIBLIOTECA]: '📖 Biblioteca',
  
  // ENTRETENIMENTO E LAZER
  [BusinessSector.CINEMA]: '🎬 Cinema',
  [BusinessSector.MUSEU]: '🏛️ Museu',
  [BusinessSector.PARQUE]: '🌳 Parque',
  [BusinessSector.ZOOLOGICO]: '🦁 Zoológico',
  [BusinessSector.PARQUE_DIVERSAO]: '🎢 Parque de Diversões',
  [BusinessSector.AQUARIO]: '🐠 Aquário',
  [BusinessSector.BOLICHE]: '🎳 Boliche',
  [BusinessSector.CASSINO]: '🎰 Cassino',
  [BusinessSector.ESTADIO]: '🏟️ Estádio',
  
  // RELIGIÃO
  [BusinessSector.IGREJA]: '⛪ Igreja',
  [BusinessSector.MESQUITA]: '🕌 Mesquita',
  [BusinessSector.SINAGOGA]: '🕍 Sinagoga',
  [BusinessSector.TEMPLO]: '🛕 Templo Hindu',
  
  // GOVERNO E SERVIÇOS PÚBLICOS
  [BusinessSector.PREFEITURA]: '🏛️ Prefeitura',
  [BusinessSector.CORREIOS]: '📮 Correios',
  [BusinessSector.DELEGACIA]: '👮 Delegacia',
  [BusinessSector.BOMBEIROS]: '🚒 Bombeiros',
  [BusinessSector.CARTORIO]: '⚖️ Cartório',
  
  // OUTROS
  [BusinessSector.FUNERARIA]: '⚰️ Funerária',
  [BusinessSector.CEMITERIO]: '🪦 Cemitério',
  [BusinessSector.EMPREITEIRO]: '👷 Empreiteiro',
  [BusinessSector.ELETRICISTA]: '⚡ Eletricista',
  [BusinessSector.ENCANADOR]: '🔧 Encanador',
  [BusinessSector.PINTOR]: '🎨 Pintor',
  [BusinessSector.CHAVEIRO]: '🔑 Chaveiro',
  [BusinessSector.MUDANCAS]: '📦 Empresa de Mudanças',
  
  // TECNOLOGIA E MÍDIA
  [BusinessSector.LOJA_INFORMATICA]: '💻 Loja de Informática',
  [BusinessSector.ASSISTENCIA_TECNICA]: '🔧 Assistência Técnica',
  [BusinessSector.GRAFICA]: '🖨️ Gráfica',
  [BusinessSector.PAPELARIA]: '📝 Papelaria',
  [BusinessSector.FOTOGRAFIA]: '📸 Estúdio Fotográfico',
  
  // ALIMENTAÇÃO ESPECIALIZADA
  [BusinessSector.PIZZARIA]: '🍕 Pizzaria',
  [BusinessSector.HAMBURGUERIA]: '🍔 Hamburgueria',
  [BusinessSector.SORVETERIA]: '🍦 Sorveteria',
  [BusinessSector.DOCERIA]: '🧁 Doceria',
  [BusinessSector.SUSHI]: '🍣 Sushi/Japonês',
  
  // SERVIÇOS ESPECIALIZADOS
  [BusinessSector.COWORKING]: '🏢 Coworking',
  [BusinessSector.DEPOSITO]: '📦 Depósito/Self Storage',
  [BusinessSector.DESPACHANTE]: '📋 Despachante',
  [BusinessSector.ARQUITETO]: '📐 Arquiteto',
  [BusinessSector.DESIGNER]: '🎨 Design de Interiores',
  
  // VAREJO ESPECIALIZADO
  [BusinessSector.OTICA]: '👓 Ótica',
  [BusinessSector.RELOJOARIA]: '⌚ Relojoaria',
  [BusinessSector.BRINQUEDOS]: '🧸 Loja de Brinquedos',
  [BusinessSector.ARTIGOS_ESPORTE]: '⚽ Artigos Esportivos',
  [BusinessSector.INSTRUMENTOS_MUSICAIS]: '🎸 Instrumentos Musicais',
  
  // ALIMENTAÇÃO SAUDÁVEL
  [BusinessSector.LOJA_PRODUTOS_NATURAIS]: '🌿 Produtos Naturais',
  [BusinessSector.SUPLEMENTOS]: '💊 Suplementos',
  
  // AUTOMOTIVO
  [BusinessSector.CONCESSIONARIA]: '🚗 Concessionária',
  [BusinessSector.BORRACHARIA]: '🛞 Borracharia',
  [BusinessSector.FUNILARIA]: '🔨 Funilaria',
  
  // CONSTRUÇÃO E REFORMA
  [BusinessSector.LOJA_MATERIAIS]: '🏗️ Materiais de Construção',
  [BusinessSector.MADEIREIRA]: '🪵 Madeireira',
  [BusinessSector.VIDRACARIA]: '🪟 Vidraçaria',
  
  // ALIMENTAÇÃO
  [BusinessSector.ACOUGUE]: '🥩 Açougue',
  [BusinessSector.PEIXARIA]: '🐟 Peixaria',
  [BusinessSector.HORTIFRUTI]: '🥬 Hortifruti',
  [BusinessSector.ADEGA]: '🍷 Adega/Vinhos',
  [BusinessSector.DISTRIBUIDORA]: '📦 Distribuidora',
  [BusinessSector.ROTISSERIA]: '🍗 Rotisseria',
  
  // BELEZA E ESTÉTICA
  [BusinessSector.MANICURE]: '💅 Manicure/Pedicure',
  [BusinessSector.TATUAGEM]: '🎨 Estúdio de Tatuagem',
  [BusinessSector.BARBEARIA]: '💈 Barbearia',
  [BusinessSector.ESTETICA]: '✨ Clínica de Estética',
  [BusinessSector.BRONZEAMENTO]: '☀️ Bronzeamento',
  
  // SAÚDE ESPECIALIZADA
  [BusinessSector.PSICOLOGO]: '🧠 Psicólogo',
  [BusinessSector.NUTRICIONISTA]: '🥗 Nutricionista',
  [BusinessSector.MASSAGEM]: '💆 Massagem/Spa',
  [BusinessSector.ACUPUNTURA]: '🎯 Acupuntura',
  [BusinessSector.LABORATORIO]: '🔬 Laboratório',
  
  // SERVIÇOS PARA CASA
  [BusinessSector.JARDINAGEM]: '🌱 Jardinagem',
  [BusinessSector.DEDETIZACAO]: '🐛 Dedetização',
  [BusinessSector.LIMPEZA]: '🧹 Limpeza',
  [BusinessSector.SEGURANCA]: '🛡️ Segurança',
  [BusinessSector.PORTARIA]: '👮 Portaria',
  
  // AUTOMOTIVO ESPECIALIZADO
  [BusinessSector.INSULFILM]: '🪟 Insulfilm',
  [BusinessSector.SOM_AUTOMOTIVO]: '🔊 Som Automotivo',
  [BusinessSector.REBOQUE]: '🚛 Reboque',
  [BusinessSector.DESPACHANTE_VEICULAR]: '📋 Despachante Veicular',
  
  // VAREJO ESPECIALIZADO
  [BusinessSector.PERFUMARIA]: '🌸 Perfumaria',
  [BusinessSector.COSMETICOS]: '💄 Cosméticos',
  [BusinessSector.TABACARIA]: '🚬 Tabacaria',
  [BusinessSector.CONVENIENCIA_POSTO]: '⛽ Conveniência (Posto)',
  
  // ENTRETENIMENTO
  [BusinessSector.KARAOKE]: '🎤 Karaokê',
  [BusinessSector.BILHAR]: '🎱 Bilhar/Sinuca',
  [BusinessSector.FLIPERAMA]: '🕹️ Fliperama',
  [BusinessSector.ESCAPE_ROOM]: '🔐 Escape Room',
  
  // TECNOLOGIA
  [BusinessSector.LAN_HOUSE]: '💻 Lan House',
  [BusinessSector.ASSISTENCIA_CELULAR]: '📱 Assistência de Celular',
  [BusinessSector.LOJA_GAMES]: '🎮 Loja de Games',
  
  // MODA E ACESSÓRIOS
  [BusinessSector.BOUTIQUE]: '👗 Boutique',
  [BusinessSector.LOJA_BOLSAS]: '👜 Bolsas e Acessórios',
  [BusinessSector.LINGERIE]: '👙 Lingerie',
  [BusinessSector.LOJA_SURF]: '🏄 Surf Shop',
  
  // ALIMENTAÇÃO ÉTNICA
  [BusinessSector.RESTAURANTE_CHINES]: '🥡 Restaurante Chinês',
  [BusinessSector.RESTAURANTE_ITALIANO]: '🍝 Restaurante Italiano',
  [BusinessSector.RESTAURANTE_MEXICANO]: '🌮 Restaurante Mexicano',
  [BusinessSector.CHURRASCARIA]: '🥩 Churrascaria',
  [BusinessSector.RESTAURANTE_VEGETARIANO]: '🥗 Restaurante Vegetariano',
  
  // SERVIÇOS DIVERSOS
  [BusinessSector.COPIADORA]: '📄 Copiadora',
  [BusinessSector.CORRETOR]: '🏡 Corretor de Imóveis',
  [BusinessSector.TRADUTOR]: '🌐 Tradutor',
  [BusinessSector.FOTOGRAFO]: '📷 Fotógrafo',
  [BusinessSector.VIDEOMAKER]: '🎥 Videomaker'
};

// Palavras-chave por setor (para busca complementar)
export const SectorKeywords: Record<BusinessSector, string[]> = {
  [BusinessSector.TODOS]: [],
  [BusinessSector.RESTAURANTE]: ['restaurante', 'comida'],
  [BusinessSector.CAFE]: ['café', 'cafeteria'],
  [BusinessSector.PADARIA]: ['padaria', 'confeitaria', 'pão'],
  [BusinessSector.BAR]: ['bar', 'pub', 'boteco'],
  [BusinessSector.LANCHONETE]: ['lanchonete', 'fast food'],
  [BusinessSector.ENTREGA_COMIDA]: ['delivery', 'entrega'],
  [BusinessSector.LOJA]: ['loja', 'comércio'],
  [BusinessSector.SHOPPING]: ['shopping', 'mall'],
  [BusinessSector.SUPERMERCADO]: ['supermercado', 'hipermercado'],
  [BusinessSector.MERCADO]: ['mercado', 'mercearia'],
  [BusinessSector.CONVENIENCIA]: ['conveniência', '24 horas'],
  [BusinessSector.LOJA_ROUPA]: ['loja de roupa', 'boutique', 'moda', 'vestuário'],
  [BusinessSector.LOJA_CALCADOS]: ['calçados', 'sapatos', 'tênis'],
  [BusinessSector.JOALHERIA]: ['joalheria', 'joias', 'ouro'],
  [BusinessSector.LOJA_MOVEIS]: ['móveis', 'estofados'],
  [BusinessSector.LOJA_ELETRONICOS]: ['eletrônicos', 'celular', 'computador'],
  [BusinessSector.LOJA_LIVROS]: ['livraria', 'livros'],
  [BusinessSector.LOJA_BICICLETAS]: ['bicicleta', 'bike'],
  [BusinessSector.FLORICULTURA]: ['floricultura', 'flores'],
  [BusinessSector.PET_SHOP]: ['pet shop', 'animais'],
  [BusinessSector.LOJA_FERRAGENS]: ['ferragens', 'ferramentas', 'construção'],
  [BusinessSector.LOJA_BEBIDAS]: ['bebidas', 'adega'],
  [BusinessSector.FARMACIA]: ['farmácia', 'drogaria', 'medicamentos'],
  [BusinessSector.LAVANDERIA]: ['lavanderia', 'tinturaria'],
  [BusinessSector.CABELEIREIRO]: ['cabeleireiro', 'barbeiro'],
  [BusinessSector.SPA]: ['spa', 'massagem'],
  [BusinessSector.BELEZA]: ['salão de beleza', 'estética'],
  [BusinessSector.ACADEMIA]: ['academia', 'ginástica', 'fitness'],
  [BusinessSector.ESTACIONAMENTO]: ['estacionamento', 'garagem'],
  [BusinessSector.POSTO_GASOLINA]: ['posto', 'gasolina', 'combustível'],
  [BusinessSector.OFICINA]: ['oficina', 'mecânica', 'auto center'],
  [BusinessSector.LAVAGEM_CARRO]: ['lava-jato', 'lavagem'],
  [BusinessSector.ALUGUEL_CARRO]: ['aluguel de carro', 'locadora'],
  [BusinessSector.HOSPITAL]: ['hospital', 'pronto-socorro'],
  [BusinessSector.CLINICA]: ['clínica', 'consultório', 'médico'],
  [BusinessSector.DENTISTA]: ['dentista', 'odontologia'],
  [BusinessSector.FISIOTERAPEUTA]: ['fisioterapia', 'fisioterapeuta'],
  [BusinessSector.VETERINARIO]: ['veterinário', 'clínica veterinária'],
  [BusinessSector.ADVOGADO]: ['advogado', 'escritório de advocacia'],
  [BusinessSector.CONTADOR]: ['contador', 'contabilidade'],
  [BusinessSector.IMOBILIARIA]: ['imobiliária', 'imóveis'],
  [BusinessSector.SEGURADORA]: ['seguradora', 'seguros'],
  [BusinessSector.AGENCIA_VIAGEM]: ['agência de viagem', 'turismo'],
  [BusinessSector.BANCO]: ['banco', 'agência bancária'],
  [BusinessSector.ATM]: ['caixa eletrônico', 'atm'],
  [BusinessSector.HOTEL]: ['hotel', 'pousada', 'hospedagem'],
  [BusinessSector.AEROPORTO]: ['aeroporto'],
  [BusinessSector.ESTACAO_ONIBUS]: ['rodoviária', 'terminal de ônibus'],
  [BusinessSector.METRO]: ['metrô', 'estação'],
  [BusinessSector.TREM]: ['trem', 'estação ferroviária'],
  [BusinessSector.TAXI]: ['táxi', 'ponto de táxi'],
  [BusinessSector.ESCOLA]: ['escola', 'colégio'],
  [BusinessSector.UNIVERSIDADE]: ['universidade', 'faculdade'],
  [BusinessSector.BIBLIOTECA]: ['biblioteca'],
  [BusinessSector.CINEMA]: ['cinema', 'filme'],
  [BusinessSector.MUSEU]: ['museu'],
  [BusinessSector.PARQUE]: ['parque', 'praça'],
  [BusinessSector.ZOOLOGICO]: ['zoológico', 'zoo'],
  [BusinessSector.PARQUE_DIVERSAO]: ['parque de diversões'],
  [BusinessSector.AQUARIO]: ['aquário'],
  [BusinessSector.BOLICHE]: ['boliche', 'bowling'],
  [BusinessSector.CASSINO]: ['cassino'],
  [BusinessSector.ESTADIO]: ['estádio', 'arena'],
  [BusinessSector.IGREJA]: ['igreja', 'templo'],
  [BusinessSector.MESQUITA]: ['mesquita'],
  [BusinessSector.SINAGOGA]: ['sinagoga'],
  [BusinessSector.TEMPLO]: ['templo hindu'],
  [BusinessSector.PREFEITURA]: ['prefeitura', 'governo'],
  [BusinessSector.CORREIOS]: ['correios', 'agência postal'],
  [BusinessSector.DELEGACIA]: ['delegacia', 'polícia'],
  [BusinessSector.BOMBEIROS]: ['bombeiros'],
  [BusinessSector.CARTORIO]: ['cartório', 'tabelião'],
  [BusinessSector.FUNERARIA]: ['funerária'],
  [BusinessSector.CEMITERIO]: ['cemitério'],
  [BusinessSector.EMPREITEIRO]: ['empreiteiro', 'construção'],
  [BusinessSector.ELETRICISTA]: ['eletricista', 'elétrica'],
  [BusinessSector.ENCANADOR]: ['encanador', 'hidráulica'],
  [BusinessSector.PINTOR]: ['pintor', 'pintura'],
  [BusinessSector.CHAVEIRO]: ['chaveiro'],
  [BusinessSector.MUDANCAS]: ['mudanças', 'fretes'],
  
  // TECNOLOGIA E MÍDIA
  [BusinessSector.LOJA_INFORMATICA]: ['informática', 'computador', 'notebook'],
  [BusinessSector.ASSISTENCIA_TECNICA]: ['assistência técnica', 'conserto', 'reparo'],
  [BusinessSector.GRAFICA]: ['gráfica', 'impressão', 'banner'],
  [BusinessSector.PAPELARIA]: ['papelaria', 'material escolar'],
  [BusinessSector.FOTOGRAFIA]: ['fotografia', 'foto', 'estúdio'],
  
  // ALIMENTAÇÃO ESPECIALIZADA
  [BusinessSector.PIZZARIA]: ['pizzaria', 'pizza'],
  [BusinessSector.HAMBURGUERIA]: ['hamburgueria', 'hambúrguer', 'burger'],
  [BusinessSector.SORVETERIA]: ['sorveteria', 'sorvete', 'açaí'],
  [BusinessSector.DOCERIA]: ['doceria', 'doces', 'bolos'],
  [BusinessSector.SUSHI]: ['sushi', 'japonês', 'comida japonesa'],
  
  // SERVIÇOS ESPECIALIZADOS
  [BusinessSector.COWORKING]: ['coworking', 'escritório compartilhado'],
  [BusinessSector.DEPOSITO]: ['depósito', 'self storage', 'guarda móveis'],
  [BusinessSector.DESPACHANTE]: ['despachante', 'documentação'],
  [BusinessSector.ARQUITETO]: ['arquiteto', 'arquitetura', 'projeto'],
  [BusinessSector.DESIGNER]: ['designer', 'design interiores', 'decoração'],
  
  // VAREJO ESPECIALIZADO
  [BusinessSector.OTICA]: ['ótica', 'óculos', 'lentes'],
  [BusinessSector.RELOJOARIA]: ['relojoaria', 'relógio'],
  [BusinessSector.BRINQUEDOS]: ['brinquedos', 'brinquedoteca'],
  [BusinessSector.ARTIGOS_ESPORTE]: ['artigos esportivos', 'esporte', 'fitness'],
  [BusinessSector.INSTRUMENTOS_MUSICAIS]: ['instrumentos musicais', 'música', 'violão'],
  
  // ALIMENTAÇÃO SAUDÁVEL
  [BusinessSector.LOJA_PRODUTOS_NATURAIS]: ['produtos naturais', 'natural', 'orgânico'],
  [BusinessSector.SUPLEMENTOS]: ['suplementos', 'whey', 'vitaminas'],
  
  // AUTOMOTIVO
  [BusinessSector.CONCESSIONARIA]: ['concessionária', 'carros', 'veículos'],
  [BusinessSector.BORRACHARIA]: ['borracharia', 'pneu', 'alinhamento'],
  [BusinessSector.FUNILARIA]: ['funilaria', 'lataria', 'pintura automotiva'],
  
  // CONSTRUÇÃO E REFORMA
  [BusinessSector.LOJA_MATERIAIS]: ['materiais construção', 'cimento', 'tijolo'],
  [BusinessSector.MADEIREIRA]: ['madeireira', 'madeira'],
  [BusinessSector.VIDRACARIA]: ['vidraçaria', 'vidro', 'espelho'],
  
  // ALIMENTAÇÃO
  [BusinessSector.ACOUGUE]: ['açougue', 'carne', 'carnes'],
  [BusinessSector.PEIXARIA]: ['peixaria', 'peixe', 'frutos do mar'],
  [BusinessSector.HORTIFRUTI]: ['hortifruti', 'frutas', 'verduras'],
  [BusinessSector.ADEGA]: ['adega', 'vinhos', 'importados'],
  [BusinessSector.DISTRIBUIDORA]: ['distribuidora', 'atacado'],
  [BusinessSector.ROTISSERIA]: ['rotisseria', 'assados'],
  
  // BELEZA E ESTÉTICA
  [BusinessSector.MANICURE]: ['manicure', 'pedicure', 'unhas'],
  [BusinessSector.TATUAGEM]: ['tatuagem', 'tattoo', 'piercing'],
  [BusinessSector.BARBEARIA]: ['barbearia', 'barber', 'corte masculino'],
  [BusinessSector.ESTETICA]: ['estética', 'procedimento', 'tratamento'],
  [BusinessSector.BRONZEAMENTO]: ['bronzeamento', 'artificial'],
  
  // SAÚDE ESPECIALIZADA
  [BusinessSector.PSICOLOGO]: ['psicólogo', 'terapia', 'psicologia'],
  [BusinessSector.NUTRICIONISTA]: ['nutricionista', 'nutrição', 'dieta'],
  [BusinessSector.MASSAGEM]: ['massagem', 'massagista', 'relaxamento'],
  [BusinessSector.ACUPUNTURA]: ['acupuntura', 'medicina chinesa'],
  [BusinessSector.LABORATORIO]: ['laboratório', 'exames', 'análises'],
  
  // SERVIÇOS PARA CASA
  [BusinessSector.JARDINAGEM]: ['jardinagem', 'jardineiro', 'paisagismo'],
  [BusinessSector.DEDETIZACAO]: ['dedetização', 'controle de pragas'],
  [BusinessSector.LIMPEZA]: ['limpeza', 'faxina', 'diarista'],
  [BusinessSector.SEGURANCA]: ['segurança', 'vigilância'],
  [BusinessSector.PORTARIA]: ['portaria', 'porteiro', 'zelador'],
  
  // AUTOMOTIVO ESPECIALIZADO
  [BusinessSector.INSULFILM]: ['insulfilm', 'película'],
  [BusinessSector.SOM_AUTOMOTIVO]: ['som automotivo', 'som carro'],
  [BusinessSector.REBOQUE]: ['reboque', 'guincho'],
  [BusinessSector.DESPACHANTE_VEICULAR]: ['despachante', 'emplacamento'],
  
  // VAREJO ESPECIALIZADO
  [BusinessSector.PERFUMARIA]: ['perfumaria', 'perfumes'],
  [BusinessSector.COSMETICOS]: ['cosméticos', 'maquiagem'],
  [BusinessSector.TABACARIA]: ['tabacaria', 'charutos', 'cigarros'],
  [BusinessSector.CONVENIENCIA_POSTO]: ['conveniência', 'posto'],
  
  // ENTRETENIMENTO
  [BusinessSector.KARAOKE]: ['karaokê', 'karaoke'],
  [BusinessSector.BILHAR]: ['bilhar', 'sinuca', 'snooker'],
  [BusinessSector.FLIPERAMA]: ['fliperama', 'arcade', 'jogos'],
  [BusinessSector.ESCAPE_ROOM]: ['escape room', 'sala fuga'],
  
  // TECNOLOGIA
  [BusinessSector.LAN_HOUSE]: ['lan house', 'cyber café', 'internet'],
  [BusinessSector.ASSISTENCIA_CELULAR]: ['assistência celular', 'conserto celular'],
  [BusinessSector.LOJA_GAMES]: ['loja games', 'videogames', 'jogos'],
  
  // MODA E ACESSÓRIOS
  [BusinessSector.BOUTIQUE]: ['boutique', 'moda feminina'],
  [BusinessSector.LOJA_BOLSAS]: ['bolsas', 'acessórios'],
  [BusinessSector.LINGERIE]: ['lingerie', 'moda íntima'],
  [BusinessSector.LOJA_SURF]: ['surf', 'praia', 'skate'],
  
  // ALIMENTAÇÃO ÉTNICA
  [BusinessSector.RESTAURANTE_CHINES]: ['chinês', 'comida chinesa'],
  [BusinessSector.RESTAURANTE_ITALIANO]: ['italiano', 'pasta', 'pizza'],
  [BusinessSector.RESTAURANTE_MEXICANO]: ['mexicano', 'tacos'],
  [BusinessSector.CHURRASCARIA]: ['churrascaria', 'churrasco', 'rodízio'],
  [BusinessSector.RESTAURANTE_VEGETARIANO]: ['vegetariano', 'vegano', 'natural'],
  
  // SERVIÇOS DIVERSOS
  [BusinessSector.COPIADORA]: ['copiadora', 'xerox', 'impressão'],
  [BusinessSector.CORRETOR]: ['corretor', 'imóveis'],
  [BusinessSector.TRADUTOR]: ['tradutor', 'tradução'],
  [BusinessSector.FOTOGRAFO]: ['fotógrafo', 'fotografia'],
  [BusinessSector.VIDEOMAKER]: ['videomaker', 'vídeo', 'produção']
};

// Informações de estabelecimento
export interface BusinessInfo {
  id: string;
  name: string;
  address: string;
  coordinates: Coordinates;
  sector?: BusinessSector;
  
  // Dados de contato
  phone?: string;
  whatsapp?: string;
  email?: string;
  website?: string;
  
  // Dados cadastrais
  cnpj?: string;
  razaoSocial?: string;
  responsible?: string;
  
  // Endereço detalhado
  city?: string;
  neighborhood?: string;
  state?: string;
  
  // Metadados
  source: 'google_places' | 'web_scraping' | 'manual' | 'multiple';
  dataQuality: number; // 0-100
  lastUpdated: Date;
  placeId?: string; // Google Places ID
  
  // Informações adicionais
  rating?: number;
  userRatingsTotal?: number;
  openingHours?: string[];
  photos?: string[];
}

// Parâmetros de busca
export interface SearchParams {
  center: Coordinates;
  radius: number; // em metros
  sector: BusinessSector;
  keywords?: string[];
}

// Resultado de busca
export interface SearchResult {
  businesses: BusinessInfo[];
  totalFound: number;
  searchParams: SearchParams;
  timestamp: Date;
}

// Estado do mapa
export interface MapState {
  center: Coordinates;
  zoom: number;
  selectedLocation?: Coordinates;
  radius: number;
  isSelectingLocation: boolean;
}

// Estado da busca
export interface SearchState {
  isSearching: boolean;
  results: BusinessInfo[];
  error?: string;
  lastSearch?: SearchParams;
}

// Configurações da aplicação
export interface AppConfig {
  googleMapsApiKey: string;
  apiBaseUrl: string;
  defaultCenter: Coordinates;
  defaultZoom: number;
  minRadius: number;
  maxRadius: number;
  defaultRadius: number;
}

// Filtros de resultados
export interface ResultFilters {
  hasPhone: boolean;
  hasWhatsapp: boolean;
  hasEmail: boolean;
  hasWebsite: boolean;
  hasCNPJ: boolean;
  minDataQuality: number;
}

// Opções de exportação
export enum ExportFormat {
  CSV = 'csv',
  EXCEL = 'excel',
  JSON = 'json'
}

// Histórico de busca
export interface SearchHistory {
  id: string;
  searchParams: SearchParams;
  resultCount: number;
  timestamp: Date;
  isFavorite: boolean;
}

